<template>
  <div class="insights-agente-de-fluxo-de-caixa">base fluxo de caixa</div>
</template>

<script setup lang="ts"></script>

<style scoped>
.insights-agente-de-fluxo-de-caixa {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
